import styled from "styled-components";

const FormBox = styled.div`
  margin-bottom: 2rem;
`;

export default FormBox;
